import { get } from 'lodash';
import React from 'react';
import Roman from 'roman-numerals';
import { FOERDERPROGRAMM_ABSCHLUSS_TEXTE_MA_PATHS } from 'src/lib/constants/componentsPath';
import { ABSCHLUSS_HINWEISE_TABS } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import Schemas
import MittelabrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import GetAbschlussContentMA from './content/GetAbschlussContentMA';
import { getFormStrucMAEinreichen } from './content/MAEinreichen';
const MA_P = MittelabrufSchema.attributes;

export const MATreeStructureAbschluss = (application: any): TreeNodeType[] => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Mittelabruf einreichen',
			content: <ApplicationHeading title={'Mittelabruf einreichen'} />,
			...GetAbschlussStructure(application),
		},
	];

	return treeNodes;
};

const GetAbschlussStructure = (application: any) => {
	let abschlussChildren = {};

	const foerderprogramm = get(application, MA_P.Foerderantrag.schema.attributes.Foerderprogramm.path, {});
	const paths = FOERDERPROGRAMM_ABSCHLUSS_TEXTE_MA_PATHS;

	const hinweisBlockSorted = sortAbschlussHinweisBlock(get(foerderprogramm, paths.AbschlussTexteBlock, []));
	const children: TreeNodeType[] = hinweisBlockSorted.map((ele: any, i: number) => {
		const tab = get(ele, paths.Tab, '');

		return {
			label: `${tab !== ABSCHLUSS_HINWEISE_TABS.Weitere ? Roman.toRoman(i + 1) + '. ' : ''} ${get(ele, paths.Titel, '')}`,
			content: <GetAbschlussContentMA hinweis={ele} paths={paths} />,
			formStruc: get(ele, paths.Tab) === ABSCHLUSS_HINWEISE_TABS.FoerderungBeantragen ? getFormStrucMAEinreichen() : [],
		};
	});

	if (children.length > 0) {
		abschlussChildren = {
			children: children,
		};
	}

	return abschlussChildren;
};

function sortAbschlussHinweisBlock(hinweisArray: any[]) {
	const tabOrder = Object.values(ABSCHLUSS_HINWEISE_TABS).filter((tab) => tab !== 'Weitere');

	// "Gültige" Hinweise nach tabOrder sortieren
	const andereHinweise = hinweisArray.filter((item) => item.Tab && item.Tab !== 'Weitere');
	const weitereHinweise = hinweisArray.filter((item) => !item.Tab || item.Tab === 'Weitere');

	const sortierteAndereHinweise = tabOrder.map((tab) => andereHinweise.find((item) => item.Tab === tab)).filter(Boolean);

	return [...sortierteAndereHinweise, ...weitereHinweise];
}
